const KEY_PREFIX = "fu:anon-activity:";

const listeners = new Set<() => void>();

function key(uid: string): string {
    return `${KEY_PREFIX}${uid}`;
}

export function markActivity(uid: string): void {
    if (typeof localStorage === "undefined" || !uid) return;
    try {
        localStorage.setItem(key(uid), "1");
    } catch {
        // Quota or privacy mode: treated as transient; nudge gating will miss but writes still work.
    }
    listeners.forEach((listener) => listener());
}

export function hasActivity(uid: string): boolean {
    if (typeof localStorage === "undefined" || !uid) return false;
    try {
        return localStorage.getItem(key(uid)) === "1";
    } catch {
        return false;
    }
}

/** Notified whenever activity is marked in this tab. Returns an unsubscribe function. */
export function subscribeActivity(listener: () => void): () => void {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}
